import { useEffect, useRef, useState, useContext } from "react";
import { UNSAFE_NavigationContext } from "react-router-dom";

export function useBeforeRouteChange(shouldActivate) {
  const [nextLocation, setNextLocation] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);
  const navigator = useContext(UNSAFE_NavigationContext).navigator;
  const originalPush = useRef(navigator.push);

  useEffect(() => {
    if (!shouldActivate) return; // do nothing if isDeleted is false

    navigator.push = (to, ...rest) => {
      setNextLocation({ to, rest });
      setShowPrompt(true);
    };

    return () => {
      navigator.push = originalPush.current;
    };
  }, [navigator, shouldActivate]);

  const confirmNavigation = () => {
    setShowPrompt(false);
    if (nextLocation) {
      originalPush.current(nextLocation.to, ...nextLocation.rest);
      setNextLocation(null);
    }
  };

  const cancelNavigation = () => {
    setShowPrompt(false);
    setNextLocation(null);
  };

  return { showPrompt, confirmNavigation, cancelNavigation };
}
